/* eslint-disable indent */
/* eslint-disable no-undef */
export default {
	name: "points-earn-management",
	data() {
		return {
			pointsToRedeem: [],
			pointsToRedeemHeadings: [
				{
					text: "Monetary Value",
					field: "monetaryValueAsString"
				},
				{
					text: "Points Redeemable Per Monetary Value",
					field: "pointValue"
				}
			],
			editPointsToRedeemModal:{
				showModal: false,
				isSaving: false,
				modalId: "editPointsToRedeemModal",
				heading: "Edit Points To Redeem",
				pointsToRedeemId: null,
				centsValue:{
					value: null,
					hasError: false,
					errorMessage: null
				},
				pointsRedeemablePerCentsValue:{
					value: null,
					hasError: false,
					errorMessage: null
				}
			},
			pagingDetails:{
				pageNumber: 1,
				pageSize: 10,
				totalPages: 1
			},
			filterStateChanged: false,
			filter:{
				fromDateCreated: null,
				toDateCreated: null,
				customerSearchQuery: null,
				activeOrInactiveItems: 1,
				gender: 0,
			},
			actions: [],
			actionKeys:{
				edit: "edit"
			},
			pageNumber: 1,
			pageSize: 100,
			loading: false,
			selectedHeartbeatStatusCodeId: null
		};
	},
	methods: {
		getPointsToRedeem(){
			this.loading = true;
			let request = {
				searchQuery: this.filter.customerSearchQuery,
				pageNumber: this.pagingDetails.pageNumber,
				pageSize: this.pagingDetails.pageSize
			};
			rewardsService.getProductPointValuesRedemptions(request).then(response => {
				if(response.status === 200){
					this.pointsToRedeem = response.data.result;
					if(response.data.pagingInfo !== null){
						this.pagingDetails.pageNumber = response.data.pagingInfo.thisPage;
						this.pagingDetails.totalPages = response.data.pagingInfo.totalPages;
					}
					for(let i = 0; i < this.pointsToRedeem.length; i++){
						this.pointsToRedeem[i].monetaryValueAsString = currencyHelper.numberToCurrency(this.pointsToRedeem[i].monetaryValue);
						this.pointsToRedeem[i].actions = [
							{
								name: "Edit",
								key: this.actionKeys.edit,
								elementId: "btnEditPointsToRedeemAction"
							}
						];
					}
					this.pointsToRedeem = dataTableHelper.castFieldValues(this.pointsToRedeem);
					this.filterStateChanged = false;
				}
				this.loading = false;
			});
		},
		onFilterSearchClicked(){
			console.log("Search filter clicked");
			this.pagingDetails.pageNumber = 1;
			this.pagingDetails.totalPages = 1;
			this.getPointsToRedeem();
		},
		onPagingUpdated(pagingInfo){
			console.log("pagingInfo", pagingInfo)
			this.pagingDetails.pageNumber = pagingInfo.pageNumber;
			this.getPointsToRedeem();
		},
		onPointsToEarnActionClicked(actionAndData){
			if(actionAndData.action === this.actionKeys.edit){
				this.editPointsToRedeemModal.pointsToRedeemId = actionAndData.data.pointValueId;
				this.editPointsToRedeemModal.centsValue.value = actionAndData.data.monetaryValue;
				this.editPointsToRedeemModal.pointsRedeemablePerCentsValue.value = actionAndData.data.pointValue;
				this.editPointsToRedeemModal.showModal = true;
			}
		},
		onEditPointsToRedeemPerCentsValueModalCloseClick(){
			this.editPointsToRedeemModal.showModal = false;
		},
		onEditPointsToRedeemPerCentsValueModalSaveClick(){
			this.editPointsToRedeemModal.isSaving = true;
			let request = {
				pointValueId: this.editPointsToRedeemModal.pointsToRedeemId,
				monetaryValue: this.editPointsToRedeemModal.centsValue.value,
				pointValue: this.editPointsToRedeemModal.pointsRedeemablePerCentsValue.value
			};
			rewardsService.updateProductPointValuesRedeem(request).then(response => {
				if(response.status === 400){
					this.editPointsToRedeemModal.centsValue.hasError = response.data.monetaryValueValidationResponse.hasError;
					this.editPointsToRedeemModal.centsValue.errorMessage = response.data.monetaryValueValidationResponse.message;
					
					this.editPointsToRedeemModal.pointsRedeemablePerCentsValue.hasError = response.data.pointValueValidationResponse.hasError;
					this.editPointsToRedeemModal.pointsRedeemablePerCentsValue.errorMessage = response.data.pointValueValidationResponse.message;
				}
				if(response.status === 200){
					this.getPointsToRedeem();
					this.editPointsToRedeemModal.showModal = false;
				}
				this.editPointsToRedeemModal.isSaving = false;
			});
		},
		setBreadcrumbs() {
			storeState.setPageTitleAction("Points Management - Redeem");
			breadcrumbsStoreState.setRootBreadcrumb(this.$route.path, "Points Management - Redeem");
		}
	},
	mounted: function () {
		this.setBreadcrumbs();
		this.getPointsToRedeem();
	}
};